// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Tags/TagsPicker/Content/SearchResult/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksViewForm_Content_Content_Tags_TagsPicker_Content_SearchResult($or: [tasks_tags_bool_exp!]) {
  tasks_tags(
    where: { type: { _eq: TASK }, _or: $or }
    limit: 50
    order_by: { name: asc }
  ) {
    id
    name
  }
}

`